import './Overlay.scss';

import cn from 'classnames';
import React from 'react';

import {
  SearchInputDefaultProps,
  SearchInputPropTypes,
} from '@/ebat/components/blocks/ScanSelfService/SearchInput/SearchInput.proptypes';
import { useScanSelfServiceAutosuggestionsContext } from '@/ebat/contexts/ScanSelfServiceContext/ScanSelfServiceAutosuggestionsContext';
import { useScanSelfServiceContext } from '@/ebat/contexts/ScanSelfServiceContext/ScanSelfServiceContext';
import { useScanSelfServiceOverlayContext } from '@/ebat/contexts/ScanSelfServiceContext/ScanSelfServiceOverlayContext';

const Overlay = ({ className }) => {
  const { clearProduct } = useScanSelfServiceContext();
  const { clearAutosuggestion } = useScanSelfServiceAutosuggestionsContext();
  const { overlayStatus } = useScanSelfServiceOverlayContext();
  const handleClick = () => {
    clearProduct();
    clearAutosuggestion();
  };

  return (
    <div
      role="presentation"
      className={cn(
        className,
        'scan-self-service-overlay',
        `scan-self-service-overlay--${overlayStatus}`,
      )}
      onClick={handleClick}
    />
  );
};

Overlay.defaultProps = {
  ...SearchInputDefaultProps,
};

Overlay.propTypes = {
  ...SearchInputPropTypes,
};

export default Overlay;
